module.exports = __webpack_public_path__ + "static/Roblox-0a988d21401f8ed24f3be70496219ebd.jpg";